import Settings from "../../assets/images/settings-icon.svg";

const settingsModule = {
  name: "Settings",
  key: "settings",
  imgSrc: Settings,
  submodules: [
    {
      name: "Role Based Access Control",
      key: "role_based_access_control",
      defaultExpanded: false,
      features: [
        {
          key: "role_based_access_control",
          name: "Role Based Access Control",
          defaultEnabled: false,
          subFeatures: [
            {
              key: "view_role_management",
              name: "View Role Management",
              defaultEnabled: true,
              description: "Access role management interface"
            },
            {
              key: "have_access_update_to_role_management",
              name: "Have access ( Update ) to Role Management",
              defaultEnabled: false,
              description: "Edit and update roles and permissions"
            }
          ]
        }
      ]
    },
    {
      name: "Marketing Management",
      key: "marketing_management",
      defaultExpanded: false,
      features: [
        {
          key: "marketing_management",
          name: "Marketing Management",
          defaultEnabled: false,
          subFeatures: [
            {
              key: "access_marketing_management",
              name: "View & Access Marketing Management",
              defaultEnabled: true,
              description: "Able to view Marketing banners"
            },
          ]
        },
        {
          key: "client_dashboard_banner",
          name: "Client Dashboard Banner",
          defaultEnabled: false,
          subFeatures: [
            {
              key: "view_client_dashboard_banner",
              name: "View Client Dashboard Banner",
              defaultEnabled: true,
              description: "Preview client dashboard banner"
            },
            {
              key: "upload_change_banner",
              name: "Upload & Change Banner",
              defaultEnabled: false,
              description: "Upload or replace client dashboard banner"
            },
            {
              key: "delete_banner",
              name: "Delete Banner",
              defaultEnabled: false,
              description: "Remove client dashboard banner"
            }
          ]
        },
        {
          key: "service_dashboard_banner",
          name: "Service Dashboard Banner",
          defaultEnabled: false,
          subFeatures: [
            {
              key: "view_service_dashboard_banner",
              name: "View Service Dashboard Banner",
              defaultEnabled: true,
              description: "Preview service dashboard banner"
            },
            {
              key: "upload_change_banner",
              name: "Upload & Change Banner",
              defaultEnabled: false,
              description: "Upload or replace service dashboard banner"
            },
            {
              key: "delete_banner",
              name: "Delete Banner",
              defaultEnabled: false,
              description: "Remove service dashboard banner"
            }
          ]
        }
      ]
    }
  ]
};

export default settingsModule;
